var qtySelector = {
    qty: 0,
    minimum: 1,
    maximum: Infinity,
    increment: 1,
    input: document.querySelector('.quantity-selector'),
    init: function () {
        if (this.qty !== this.minimum) {
            this.qty = this.minimum;
            this.input.value = this.minimum;
        }
    },
    doChange: function (direction) {
        var val = 0;

        switch(direction) {
            case 'up':
                if ( (this.qty >= this.minimum && this.qty <= this.maximum) && ((this.qty + this.increment) <= this.maximum) ) {
                    val = (parseInt(this.input.value) + this.increment);
                }
                break;
            case 'down':
                if ( this.qty > 0 && this.qty != this.minimum ) {
                    val = (parseInt(this.input.value) - this.increment);
                }
                break;
        }
        this.qty = (val || this.qty);
        this.input.value = (val || this.qty);
    }
};

(function() {
    if (document.querySelector('.quantity-selector')) {
        document.querySelector('.increase').addEventListener('click', function (e) {
            e.preventDefault();
            qtySelector.doChange('up');
        });

        document.querySelector('.decrease').addEventListener('click', function (e) {
            e.preventDefault();
            qtySelector.doChange('down');
        });

        document.querySelector('.quantity-selector').addEventListener('click', function (e) {
            e.preventDefault();
        });

        qtySelector.init();
    }
})();
